import React, { useEffect, useState } from "react";
import Button from "../../component/Button";
import classes from "./style.module.scss";
import NotificationTableList from "./components/NotificationTableList";
import { useLocation, useNavigate } from "react-router-dom";
import SearchBox from "../../component/SearchBox";
import ViewNotifyDetails from "./components/ViewNotifyDetails";
import CreateNotifications from "../../modalComponents/CreateNotifications";
import SuccessModal from "../../modalComponents/SuccessModal";
import ScheduleNotifications from "../../modalComponents/ScheduleNotifications";
import Exported from "../../service/endpoints";
import request from "../../service";
import { Toast } from "../../service/toast";
import { saveLoadingState } from "../../redux/reducers/loadingSlice";
import { useDispatch } from "react-redux";
import GetUserPermission from "../../component/GetUserPermission";

const ManageNotification = () => {
  const [viewDetails, setViewDetails] = useState(false);
  const [createNotificationModal, setCreateNotificationModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showSchedulerModal, setShowSchedulerModal] = useState(false);
  const [schedulerData, setSchedulerData] = useState(null);
  const [searchInput, setSearchInput] = useState("");
  const [isLoading, setisLoading] = useState(false);
  const [sortConfig, setSortConfig] = useState(null);
  const [page, setPage] = useState(1);
  const [userList, setUserList] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const addPermission = GetUserPermission({ key: 'add' });

  useEffect(() => {
    if (location?.pathname) {
      const pathName = location?.search?.split("?id=");
      const params = pathName[pathName?.length - 1];
      if (params) {
        setViewDetails(true);
      } else {
        setViewDetails(false);
      }
    }
  }, [location]);

  const handleChange = (value) => {
    setSearchInput(value);
  };

  // Scheduler Modal
  const handleScheduleModal = (formData) => {
    setShowSchedulerModal(true);
    setSchedulerData(formData);
    setCreateNotificationModal(false);
  };
  const handleSchedulerSuccess = () => {
    setShowSchedulerModal(false);
    setShowSuccessModal(true);
  };
  const handleSchedulerClose = () => {
    setShowSchedulerModal(false);
  };
  // Create Notification Modal
  const handleNotificationClose = () => {
    setCreateNotificationModal(false);
  };

  const handleNotificationSuccess = () => {
    setCreateNotificationModal(false);
    setShowSuccessModal(true);
  };
  // Success Modal
  const handleSuccessClose = () => {
    setShowSuccessModal(false);
    redirectBack();
  };

  const redirectBack = () => {
    navigate(`/admin/notification`);
  };

  const getNotificationId = () => {
    const pathName = location?.search?.split("?id=");
    const params = pathName[pathName?.length - 1];
    return params;
  };

  const getNotificationList = async () => {
    setisLoading(true);
    let url = `${Exported.Endpoints.getNotification}`;
    let paramsObj = {
      page: page,
      limit: 10,
    };

    if (searchInput && searchInput !== "") {
      paramsObj["search"] = searchInput;
    }
    if (sortConfig) {
      paramsObj["sort"] = sortConfig?.key;
      paramsObj["sortOrder"] = sortConfig?.direction;
    }

    await request({
      url: url,
      params: { ...paramsObj },
    })
      .then((res) => {
        if (res?.data?.status) {
          const obj = {
            result: res?.data?.data?.list,
            pageMeta: res?.data?.data?.pageMeta,
          };
          setUserList(obj);
        }
      })
      .catch((err) => {
        Toast({
          type: "error",
          message: "Unable to process the request!..",
        });
      });
    setisLoading(false);
  };

  useEffect(() => {
    getNotificationList();
  }, [page, searchInput, sortConfig]);

  const handleDelete = async (notification_id) => {
    dispatch(saveLoadingState(true));
    let url = `${Exported.Endpoints.getNotificationByID}`;
    let paramsObj = {
      notification_id: notification_id,
    };

    const requestData = {
      notification_id: notification_id,
    };
    await request({
      url: url,
      method: Exported.APIMethods.DELETE,
      data: requestData,
      params: { ...paramsObj },
    })
      .then(async (res) => {
        if (res?.data?.status) {
          await getNotificationList();
          Toast({
            type: "success",
            message: "Deleted successfully",
          });
        }
      })
      .catch((err) => {
        Toast({
          type: "error",
          message: "Unable to process the request!..",
        });
      });
    dispatch(saveLoadingState(false));
  };

  return (
    <>
      {viewDetails ? (
        <ViewNotifyDetails
          viewDetails={viewDetails}
          notification_id={getNotificationId()}
          handleDelete={handleDelete}
          setCreateNotificationModal={setCreateNotificationModal}
        />
      ) : (
        <div className={`${classes.manageUserWrapper}`}>
          <div className={`w-[100%] flex items-center justify-between`}>
            <div className={`layout-title`}>Manage Notifications</div>
            <div className="flex items-center">
              <SearchBox
                value={searchInput}
                onChange={handleChange}
                placeholder={"Find by ID, date..."}
              />
              {addPermission &&
                <Button
                  text={"Create New Notification"}
                  smallBtn
                  className={'ml-5'}
                  onClick={() => setCreateNotificationModal(true)}
                />
              }
            </div>
          </div>
          <div>
            <NotificationTableList isLoading={isLoading}
              setisLoading={setisLoading}
              sortConfig={sortConfig}
              setSortConfig={setSortConfig}
              page={page}
              setPage={setPage}
              userList={userList}
              handleDelete={handleDelete} />
          </div>
        </div>
      )}
      {createNotificationModal ? (
        <CreateNotifications
          isOpen={createNotificationModal}
          closePopUp={handleNotificationClose}
          handleSuccessModal={handleNotificationSuccess}
          handleScheduleModal={handleScheduleModal}
          getNotificationList={getNotificationList}
          notification_id={getNotificationId()}
          isEdit={isEdit}
          setIsEdit={setIsEdit}
        />
      ) : null}
      {showSchedulerModal ? (
        <ScheduleNotifications
          isOpen={showSchedulerModal}
          closePopUp={handleSchedulerClose}
          notifyData={schedulerData}
          handleSuccessModal={handleSchedulerSuccess}
          getNotificationList={getNotificationList}
          notification_id={getNotificationId()}
          isEditDate={isEdit} 
        />
      ) : null}
      {showSuccessModal ? (
        <SuccessModal
          isOpen={showSuccessModal}
          closePopUp={handleSuccessClose}
          successText={"Success!"}
          modalText={
            "Notification message has been sent successfully to the selected recipient."
          }
        />
      ) : null}
    </>
  );
};

export default ManageNotification;
